import React from "react"
import { toast } from "react-toastify"

toast.configure({
  autoClose: 5000,
  draggable: false,
});

const Toasts = () => {
  return <></>
}

export default Toasts;
